module.exports = __webpack_public_path__ + "media/1100_3_HC_2023_Phyical_Security.12c46512.mp4";